var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "scan",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M13.29,144.377H24.81a1.34,1.34,0,0,1,.268,2.664c-.13.008-.259.008-.4.008H1.819a2.35,2.35,0,0,1-.6-.05,1.318,1.318,0,0,1-.924-1.47,1.282,1.282,0,0,1,1.224-1.143c1.094-.017,2.189-.008,3.283-.008Z",
    transform: "translate(-0.262 -132.717)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M0,6.163A22.928,22.928,0,0,1,.126,3.524,3.928,3.928,0,0,1,3.857.281C5.277.247,6.688.264,8.108.272A1.318,1.318,0,0,1,9.436,1.617,1.321,1.321,0,0,1,8.117,2.936c-1.269.017-2.538.008-3.806.008a1.4,1.4,0,0,0-1.6,1.6c0,1.277.008,2.563-.008,3.84A1.305,1.305,0,0,1,1.529,9.658,1.347,1.347,0,0,1,.084,8.692a1.949,1.949,0,0,1-.05-.5c-.008-.681,0-1.361,0-2.05A.034.034,0,0,1,0,6.163Z",
    transform: "translate(0 -0.239)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M211.915,0a22.928,22.928,0,0,1,2.638.126,3.931,3.931,0,0,1,3.252,3.756c.034,1.4.017,2.815.008,4.218a1.332,1.332,0,1,1-2.664-.017c-.008-1.269,0-2.538-.008-3.806a1.393,1.393,0,0,0-1.571-1.571c-1.294,0-2.58.008-3.874-.008a1.3,1.3,0,0,1-1.218-.924,1.256,1.256,0,0,1,.462-1.454,1.879,1.879,0,0,1,.874-.277c.7-.042,1.4-.017,2.109-.017C211.915.025,211.915.008,211.915,0Z",
    transform: "translate(-191.847)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M6.163,217.743a22.928,22.928,0,0,1-2.638-.126,3.922,3.922,0,0,1-3.243-3.739c-.034-1.412-.017-2.832-.008-4.252A1.318,1.318,0,0,1,1.617,208.3a1.318,1.318,0,0,1,1.319,1.328c.017,1.277.008,2.563.008,3.84a1.393,1.393,0,0,0,1.58,1.563c1.294,0,2.58-.008,3.874.008a1.305,1.305,0,0,1,1.269,1.176,1.329,1.329,0,0,1-.966,1.437,1.948,1.948,0,0,1-.5.05c-.681.008-1.361,0-2.05,0A.091.091,0,0,1,6.163,217.743Z",
    transform: "translate(-0.239 -191.743)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M217.743,211.875a22.928,22.928,0,0,1-.126,2.638,3.922,3.922,0,0,1-3.739,3.235c-1.42.034-2.832.017-4.252.008a1.336,1.336,0,0,1,0-2.672c1.277-.017,2.563,0,3.84-.008a1.38,1.38,0,0,0,1.554-1.546c0-1.294-.008-2.58.008-3.874a1.312,1.312,0,0,1,.907-1.235,1.269,1.269,0,0,1,1.462.445,1.867,1.867,0,0,1,.294.865c.042.714.017,1.428.017,2.143Z",
    transform: "translate(-191.743 -191.79)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.df12749d42ec43daf6f446033f0532a8.svg";
export { ForwardRef as ReactComponent };